import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { ResponsiveImageContainer } from './responsive-image-container.js';
import { ResponsiveImage } from './responsive-image.component.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
const propTypes = {
  aspectRatio: PropTypes.number.isRequired
};
const BasicResponsiveImage = renderWithRef('BasicResponsiveImage', propTypes, (_param, ref) => {
  var {
      aspectRatio
    } = _param,
    props = _objectWithoutProperties(_param, ["aspectRatio"]);
  return /*#__PURE__*/React.createElement(ResponsiveImageContainer, {
    aspectRatio: aspectRatio
  }, /*#__PURE__*/React.createElement(ResponsiveImage, _extends({}, props, {
    ref: ref
  })));
});
export { BasicResponsiveImage };